"use strict";

exports.__esModule = true;
exports.FormProvider = exports.FormContext = void 0;

var _react = require("react");

var FormContext = (0, _react.createContext)(null);
exports.FormContext = FormContext;
var FormProvider = FormContext.Provider;
exports.FormProvider = FormProvider;